<template>
  <v-container
    id="extended-forms"
    fluid
    tag="bankAccount"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-bank"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingBankAccount"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="bankAccount.bankName"
                        >
                          <v-text-field
                            v-model="bankAccount.bankName"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.bankAccount.bankName')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="bankAccount.accountNumber"
                        >
                          <v-text-field
                            v-model="bankAccount.accountNumber"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.bankAccount.accountNumber')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="bankAccount.accountIbanNumber"
                        >
                          <v-text-field
                            v-model="bankAccount.accountIbanNumber"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.bankAccount.accountIbanNumber')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const bankAccountsRespository = repositoryFactory.get('bankAccounts')

  export default {
    inject: ['theme'], // ??
    name: 'BankAccountCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      bankAccount: {},
      showErrorMessage: false,
      errorMessage: '',
      loadingBankAccount: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-bankAccount') : this.$t('modify-bankAccount')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingBankAccount = true
        var id = this.$route.params.id
        bankAccountsRespository.getById(id).then(response => {
          self.loadingBankAccount = false
          self.bankAccount = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingBankAccount = false
          alert(err)
        })
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.bankAccount,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          bankAccountsRespository.updateBankAccount(data, this.bankAccount.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          bankAccountsRespository.addBankAccount(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'bankAccounts' })
      },
    },
  }
</script>
